import { render, staticRenderFns } from "./airtight.vue?vue&type=template&id=bf2ef5ba&scoped=true"
import script from "./airtight.vue?vue&type=script&lang=js"
export * from "./airtight.vue?vue&type=script&lang=js"
import style0 from "./airtight.vue?vue&type=style&index=0&id=bf2ef5ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2ef5ba",
  null
  
)

export default component.exports